import { useContext, useState } from "react";
import { DatePicker, Flex, Segmented, Select } from "antd";
import dayjs from "dayjs";
import { filtrationcontext } from "../../context/Filtercontext";
import trans from "../../utils";
import Searchbar from "../Helpers/Searchbar/Searchbar";
import {
  AppstoreOutlined,
  BarsOutlined,
  HomeOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { usePois } from "../../hooks/usePOIs";
import { useTechnicians } from "../../hooks/useTechnicians";
import { InputSelect } from "../Helpers/Input/RefactoredInput";
const { RangePicker } = DatePicker;

export default function TasksHeader({
  viewMode,
  setViewMode,
  selectedRange,
  setSelectedRange,
  selectedDate,
  setSelectedDate,
  selectedPOIs,
  setSelectedPOIs,
  selectedStaff,
  setSelectedStaff,
}) {
  const { setSearchQuery } = useContext(filtrationcontext);
  const [query, setQuery] = useState("");
  const { options: poisOptions, isFetching: poiLoading } = usePois();
  const { options: staffOptions, isFetching: staffLoading } = useTechnicians();
  const handleSearch = (e) => {
    setQuery(e.target.value);
    setSearchQuery(e.target.value);
  };

  return (
    <div className="bg-white p-4">
      <Flex
        vertical={false}
        align="center"
        justify="space-between"
        gap="middle"
      >
        <Flex style={{ flex: 1 }} align="center">
          <Searchbar
            placeholder={trans("Search")}
            value={query}
            onChange={handleSearch}
          />
        </Flex>
        {/* {viewMode === "Kanban" ? (
          <DatePicker
            value={selectedDate || dayjs()}
            defaultValue={dayjs()}
            onChange={(date) => setSelectedDate(date || dayjs())}
            format="DD, MMMM, YYYY"
            style={{ minWidth: 300 }}
            allowClear={false}
          />
        ) : ( */}
        <RangePicker
          value={selectedRange}
          defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
          onChange={(dates) => {
            if (dates) {
              setSelectedRange(dates);
            } else {
              setSelectedRange([dayjs().startOf("day"), dayjs().endOf("day")]);
            }
          }}
          format="DD, MMM YYYY"
          style={{ minWidth: 300 }}
          allowClear={false}
          showTime={{ format: "HH:mm" }}
        />
        {/* )} */}
        {viewMode === "Kanban - POI" && (
          <Flex vertical={false} gap={"small"}>
            <Select
              mode="multiple"
              allowClear
              placeholder={trans("Select POI")}
              style={{ width: 200 }}
              maxTagCount={"responsive"}
              value={selectedPOIs}
              onChange={(value) => setSelectedPOIs(value)}
            >
              {poisOptions.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Flex>
        )}
        {viewMode === "Kanban - Staff" && (
          <Flex vertical={false} gap={"small"}>
            <InputSelect
              placeholder={trans("Select field staff")}
              options={staffOptions}
              loading={staffLoading}
              value={selectedStaff || []}
              onChange={(value) => setSelectedStaff(value)}
              mode="multiple"
              width="200px"
              optionRender={(option) => (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {option.data.avatar ? (
                    <img
                      src={option.data.avatar}
                      alt={option.label}
                      style={{ width: 24, height: 24, borderRadius: "50%" }}
                    />
                  ) : (
                    <UserOutlined
                      style={{ width: 24, height: 24, borderRadius: "50%" }}
                    />
                  )}
                  <span>{option.label}</span>
                </div>
              )}
            />
          </Flex>
        )}
        <Flex vertical={false} gap={"small"}>
          <Segmented
            options={[
              {
                label: trans("Tasks Board"),
                value: "Kanban",
                icon: <AppstoreOutlined />,
              },
              {
                label: trans("POI Board"),
                value: "Kanban - POI",
                icon: <HomeOutlined />,
              },
              {
                label: trans("Staff Board"),
                value: "Kanban - Staff",
                icon: <UserOutlined />,
              },
              { label: trans("List"), value: "List", icon: <BarsOutlined /> },
            ]}
            value={viewMode}
            onChange={setViewMode}
          />
        </Flex>
      </Flex>
    </div>
  );
}
